// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__jW9Qx","col":"styles_col__EU9yX","fulfillmentStatus":"styles_fulfillmentStatus__1jM4K","emailCol":"styles_emailCol__2dCBG"};